// put nearest product and most whispered product on first places
export default function sortProducts(products) {
  if (products.length === 0) {
    return {hasOneHighlightProductOnly: false, sortedProducts: []};
  }
  let minDistance = products[0].distance;
  let maxSecretCount = products[0].secretCount;
  let minDistancePosition = 0;
  let maxSecretCountPosition = 0;
  for (let i = 1; i < products.length; i++) {
    if (products[i].distance < minDistance) {
      minDistance = products[i].distance;
      minDistancePosition = i;
    }
    if (products[i].secretCount > maxSecretCount) {
      maxSecretCount = products[i].secretCount;
      maxSecretCountPosition = i;
    }
  }
  const hasOneHighlightProductOnly = minDistancePosition === maxSecretCountPosition || !maxSecretCount;
  const sortedProducts = hasOneHighlightProductOnly ? 
    [products[minDistancePosition]] : 
    [products[minDistancePosition], products[maxSecretCountPosition]];
  // instead of filter to maximize performance (no copy)
  for (let i = 0; i < products.length; i++) {
    if (!(i === minDistancePosition || (!hasOneHighlightProductOnly && i === maxSecretCountPosition))) {
      sortedProducts.push(products[i]);
    }
  }
  return {hasOneHighlightProductOnly, sortedProducts};
}
